/**
* [Flags]
*/
export var RuleOutputVisibility;
(function (RuleOutputVisibility) {
    RuleOutputVisibility[RuleOutputVisibility["TrueOnly"] = 1] = "TrueOnly";
    RuleOutputVisibility[RuleOutputVisibility["FalseOnly"] = 2] = "FalseOnly";
    RuleOutputVisibility[RuleOutputVisibility["TrueAndFalse"] = 3] = "TrueAndFalse";
    RuleOutputVisibility[RuleOutputVisibility["MissingData"] = 4] = "MissingData";
    RuleOutputVisibility[RuleOutputVisibility["All"] = 7] = "All";
})(RuleOutputVisibility || (RuleOutputVisibility = {}));
;
